module.exports = __webpack_public_path__ + "static/img/zzgy.2dc9570.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/zzgy.jpg
// module id = Haaa
// module chunks = 1